var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { useEffect } from 'react';
import { Client } from 'twilio-chat';
import { refreshAccessToken } from '../../../../../apis/refreshAccessToken';
import { Types } from '../../../../states/actions';
/**
 * `useClient` hook can be used to create a Twilio SDK client
 *
 * @param chatState
 * @param dispatch
 * @param sessionToken
 * @param apiBaseurl
 */
export function useClient(chatState, dispatch, sessionToken, apiBaseurl) {
    var _this = this;
    var client = chatState.client, accessToken = chatState.accessToken, channelId = chatState.channelId;
    // Whenever user accessToken is updated, we wish to either
    // 1. Create client
    // 2. Update client
    // 3. Remove client
    useEffect(function () {
        var getClientAsync = function (accessToken) { return __awaiter(_this, void 0, void 0, function () {
            var client, err_1;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, Client.create(accessToken)];
                    case 1:
                        client = _a.sent();
                        return [3 /*break*/, 3];
                    case 2:
                        err_1 = _a.sent();
                        throw new Error("@lendi/chat: unable to create Twilio client: ".concat(err_1));
                    case 3:
                        if (client) {
                            client.on('connectionError', function (connError) {
                                throw new Error("@lendi/chat: useClient: ConnectionError object: %c".concat(JSON.stringify(connError, undefined, 2)));
                            });
                            // when an access token is in its final three minutes, the token about to expire event is triggered
                            client.on('tokenAboutToExpire', function () { return __awaiter(_this, void 0, void 0, function () {
                                var accessToken;
                                return __generator(this, function (_a) {
                                    switch (_a.label) {
                                        case 0: return [4 /*yield*/, refreshAccessToken(sessionToken, apiBaseurl, channelId)];
                                        case 1:
                                            accessToken = (_a.sent()).accessToken;
                                            // Once we receive the latest Twilio accessToken, we can dispatch it to chatState, which would in turn trigger updateToken() method from above.
                                            dispatch({ type: Types.UPDATE_ACCESS_TOKEN, payload: accessToken });
                                            return [2 /*return*/];
                                    }
                                });
                            }); });
                        }
                        // eslint-disable-next-line no-console
                        console.log('PC client');
                        dispatch({
                            type: Types.UPDATE_CLIENT,
                            payload: client,
                        });
                        return [2 /*return*/];
                }
            });
        }); };
        if (accessToken) {
            dispatch({
                type: Types.LOADING,
                payload: true,
            });
            if (client) {
                // Twilio Client already initiated, only update AccessToken
                client.updateToken(accessToken); // TODO: Error Handling
            }
            else {
                getClientAsync(accessToken); // TODO: Error Handling
            }
            dispatch({
                type: Types.LOADING,
                payload: false,
            });
        }
        else {
            // Access Token was removed
            dispatch({
                type: Types.UPDATE_CLIENT,
                payload: undefined,
            });
        }
    }, [accessToken]);
}
//# sourceMappingURL=index.js.map